import React, { useEffect, useState } from 'react'
// import { Col, Row } from 'react-bootstrap'
import AutoSuggestionsdata from './Autosuggestionsdata'
import CrewUi from './CrewUi'
// import DraganddropField from './Draganddropfield'
import getFormattedData from './GetFormattedData'
import rendercrew from './rendermcrew'

const Crew = props => {
  // props for this file
  const {
    inputData,
    sendinputdata,
    name,
    inputFieldEnglish,
    inputFieldTelugu,
    weight,
    truevalue,
    sendtruevalue,
  } = props
  // state variables for this file
  const [PersonsSelectedAutosuggestions, setPersonsSelectedAutosuggestions] = useState([])
  const [crewName, setcrewName] = useState('')
  const [crewNameTelugu, setcrewNameTelugu] = useState('')
  const [filteredcrewNames, setfilteredcrewNames] = useState([])
  const [filteredcrewNameste, setfilteredcrewNamesTelugu] = useState([])
  const [searchBoolean, setsearchBoolean] = useState(true)
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [crewArray, setcrewArray] = useState([])
  const [editMode, seteditMode] = useState(true)
  // funtion to recive editMode from child component
  const sendEditmode = data => {
    seteditMode(data)
  }

  const crewEnglish = event => {
    if (event.target.value) {
    setcrewName(event.target.value)
    } else {
      setsearchBoolean(true)
      handleCrewNameChange('')
      setcrewNameTelugu('')
    }
  }

  // Boolean for search active or not
  const sendSearchBoolean = data => {
    setsearchBoolean(data)
  }

  const crewTelugu = event => {
    setcrewNameTelugu(event.target.value)
  }

  // function to recive crewName from child Component
  const sendcrewName = data => {
    setcrewName(data)
  }

  // function to recive crewNameTelugu from child Component
  const sendcrewNameTelugu = data => {
    setcrewNameTelugu(data)
  }

  // function to sendinput object back to parent
  const sendInputobjecttoParent = async (valueOne, valueTwo) => {
    const dataFeilds = {
      valueOne,
      valueTwo,
    }
    const field = [inputFieldEnglish, inputFieldTelugu]
    const formattedData = await getFormattedData(inputData, dataFeilds, field)

    sendinputdata(formattedData)
  }

  // funtion to form requied object and send to parent
  const SubmitCrewperson = () => {
    const crewEnglishTemp = [...inputData[inputFieldEnglish]]
    const crewTeluguTemp = [...inputData[inputFieldTelugu]]
    const crewNameTeluguTemp = crewNameTelugu
    seteditMode(true)
    sendtruevalue('crew', true)
    const crewNameTemp = crewName
    if (crewArray.some(obj => obj.name_En === crewNameTemp) === true) {
      const selectedPersonIndex = crewArray.findIndex(obj => obj.name_En === crewNameTemp)
      const arrobj = crewArray[selectedPersonIndex]
      if (Object.keys(arrobj).some(key => key === 'GSIPersonStatusAndPersonID') === true) {
        const crewPersonObject = {}
        crewPersonObject.PK = arrobj.PK
        crewPersonObject.SK = arrobj.SK
        crewPersonObject.name_En = arrobj.name_En
        crewPersonObject.name_Te = crewNameTeluguTemp
        crewPersonObject.personID = arrobj.PK
        crewPersonObject.personUUID = arrobj.personUUID
        crewPersonObject.weight = weight + 1
        crewPersonObject.role = `${name}`
        crewPersonObject.posterURL = arrobj.posterURL
        crewPersonObject.isAnonymous = arrobj.isAnonymous
        crewPersonObject.GSIPersonStatusAndPersonID = arrobj.GSIPersonStatusAndPersonID
        crewEnglishTemp.push(crewPersonObject)
      } else {
        const crewPersonObject = {}
        crewPersonObject.newPerson = true
        crewPersonObject.PK = arrobj.PK
        crewPersonObject.SK = arrobj.SK
        crewPersonObject.name_En = arrobj.name_En
        crewPersonObject.name_Te = crewNameTeluguTemp
        crewPersonObject.personID = arrobj.PK
        crewPersonObject.personUUID = arrobj.personUUID
        crewPersonObject.weight = weight + 1
        crewPersonObject.role = `${name}`
        crewPersonObject.posterURL = arrobj.posterURL
        crewEnglishTemp.push(crewPersonObject)
      }
    } else {
      crewEnglishTemp.push({
        newPerson: true,
        name_En: crewNameTemp,
        name_Te: crewNameTelugu,
        role: `${name}`,
        weight: weight + 1,
        isAnonymous: true,
      })
    }

    if (crewNameTeluguTemp.length === 0) {
      const crewfield = `(${crewName})*`
      crewTeluguTemp.push(crewfield)
      sendInputobjecttoParent(crewEnglishTemp, crewTeluguTemp)
    } else {
      crewTeluguTemp.push(crewNameTeluguTemp)
      sendInputobjecttoParent(crewEnglishTemp, crewTeluguTemp)
    }

    setcrewName('')
    setfilteredcrewNames([])
    setcrewNameTelugu('')
    setsearchBoolean(true)
  }

  // selecting crewPerson from autosuggestion
  const crewSelectionFromSuggestion = selectedPersonTelugunameIndex => {
    sendtruevalue('crew', true)
    // const regex = /Create [A-Za-z]+/i

    if ((selectedPersonTelugunameIndex === 0)) {
      setsearchBoolean(false)
    } else {
      const crewEnglishTemp = [...inputData[inputFieldEnglish]]
      const crewTeluguTemp = [...inputData[inputFieldTelugu]]
      const selectedPersonFromSuggestion = filteredcrewNameste[selectedPersonTelugunameIndex - 1]
if (!crewTeluguTemp.includes(selectedPersonFromSuggestion.label)) {
  crewTeluguTemp.push(
     selectedPersonFromSuggestion.label)
}

      const crewNamesTemp = [...PersonsSelectedAutosuggestions]
      const personID = filteredcrewNameste[selectedPersonTelugunameIndex - 1].PK
const existingPerson = crewNamesTemp.find(person => person.personID === personID)

if (existingPerson === -1) {
  crewNamesTemp.push({
    label: filteredcrewNames[selectedPersonTelugunameIndex - 1].label,
    labelte: filteredcrewNameste[selectedPersonTelugunameIndex - 1].label,
    personID,
    posterURL: filteredcrewNameste[selectedPersonTelugunameIndex - 1] ? filteredcrewNameste[selectedPersonTelugunameIndex - 1].posterURL : '',
  })
}

      const crewArrayTemp = [...crewArray]
      crewArrayTemp.push(autoSuggestions.personHits[selectedPersonTelugunameIndex - 1])

      setcrewArray(crewArrayTemp)
      setPersonsSelectedAutosuggestions(crewNamesTemp)
      const selectedPerson = autoSuggestions.personHits[selectedPersonTelugunameIndex - 1]
      const crewPersonObject = {}
      crewPersonObject.newPerson = true
      crewPersonObject.PK = selectedPerson.PK
      crewPersonObject.SK = selectedPerson.SK
      crewPersonObject.name_En = selectedPerson.name_En
      crewPersonObject.name_Te = selectedPerson.name_Te
      crewPersonObject.personID = selectedPerson.PK
      crewPersonObject.personUUID = selectedPerson.personUUID
      crewPersonObject.posterURL = selectedPerson.posterURL ? selectedPerson.posterURL : ''
      crewPersonObject.weight = weight + 1
      crewPersonObject.role = `${name}`

      crewEnglishTemp.push(crewPersonObject)

      sendInputobjecttoParent(crewEnglishTemp, crewTeluguTemp)
      setcrewName('')
      setcrewNameTelugu('')
      setfilteredcrewNames([])
    }
  }

  // function to handle input and get autosuggestions
  const handleCrewNameChange = async value => {
    setcrewName(value)
    if (value === '') {
      setfilteredcrewNames([])
    }

    if (value.length >= 3) {
      try {
        const moviePersonData = await AutoSuggestionsdata(value)
        setAutoSuggestions(moviePersonData)
        // console.log(moviePersonData, 'moviePersonData')
        const filteredcrewNames = moviePersonData
          ? moviePersonData.personHits.map(e => ({ label: e.name_En, personID: e.personID ? e.personID : e.PK, ...e }))
          : []
        const filteredcrewNameste = moviePersonData
          ? moviePersonData.personHits.map(e => ({ label: e.name_Te, personID: e.personID ? e.personID : e.PK, ...e }))
          : []
        setfilteredcrewNames(filteredcrewNames)
        setfilteredcrewNamesTelugu(filteredcrewNameste)
      } catch {
        setAutoSuggestions([])
        setfilteredcrewNames([])
        setfilteredcrewNamesTelugu([])
        // console.warn(error)
      }
    }
  }

  // To display create above autosuggested names
  const finalfilteredcrewNames = [...filteredcrewNames]
  if (crewName.length >= 3) {
    finalfilteredcrewNames.unshift({ label: `Create ${crewName}` })
  }

  useEffect(() => {
    if (props.movieData && name) {
      setcrewArray(rendercrew(props.movieData, name))
    }
    // setcrewArray(props.movieData && props.movieData.Crew && props.movieData.Crew[name] ? props.movieData.Crew[name] : [])
  }, [props.movieData, name])
// console.log(inputData[inputFieldEnglish], 'input')
  return (
    <div>
      <CrewUi
        name={name}
        inputData={inputData}
        inputFieldEnglish={inputFieldEnglish}
        truevalue={truevalue}
        sendtruevalue={sendtruevalue}
        inputFieldTelugu={inputFieldTelugu}
        crewName={crewName}
        crewNameTelugu={crewNameTelugu}
        sendcrewName={sendcrewName}
        sendcrewNameTelugu={sendcrewNameTelugu}
        sendInputobjecttoParent={sendInputobjecttoParent}
        sendSearchBoolean={sendSearchBoolean}
        PersonsSelectedAutosuggestions={PersonsSelectedAutosuggestions}
        sendEditmode={sendEditmode}
        editMode={editMode}
        searchBoolean={searchBoolean}
        weight={weight}
        handleCrewNameChange={handleCrewNameChange}
        finalfilteredcrewNames={finalfilteredcrewNames}
        crewSelectionFromSuggestion={crewSelectionFromSuggestion}
        crewEnglish={crewEnglish}
        crewTelugu={crewTelugu}
        SubmitCrewperson={SubmitCrewperson}
        editData={props.editData}
        modeUrl={props.modeUrl}
        active={props.active}
        handleActiveChange={props.handleActiveChange}
      />
      {inputData[inputFieldEnglish].length < 1 && (name === 'Director' || name === 'Producer') ? (
        <div className='mandatory1'>{name} should not be empty</div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default Crew
